import React from 'react'

import {
  TableBodyStyled,
  TableCellStyled,
  TableContainerStyled,
  TableHeadStyled,
  TableRowStyled,
  TableStyled
} from 'components'
import { COLORS } from 'utils'

// import { Container } from './styles';
interface ITableContract {
  tableData: any[]
}
const TableContract: React.FC<ITableContract> = ({ tableData }) => {
  const handleCalcTotal = (name: string) => {
    let total = 0
    tableData?.forEach((obj) => {
      total += parseInt(obj[name])
    })
    return total
  }
  return (
    <TableContainerStyled>
      <TableStyled>
        <TableHeadStyled>
          <TableRowStyled>
            <TableCellStyled align="left">Mês/Ano</TableCellStyled>
            <TableCellStyled align="left">Status Movimentação</TableCellStyled>
            <TableCellStyled align="left">Ativo</TableCellStyled>
            <TableCellStyled align="left">Demitido</TableCellStyled>
            <TableCellStyled align="left">Eventual</TableCellStyled>
            <TableCellStyled align="left">Acesso</TableCellStyled>
            <TableCellStyled align="left">Afastado</TableCellStyled>
            <TableCellStyled align="left">Substituo</TableCellStyled>
            <TableCellStyled align="left">Transferido</TableCellStyled>
            <TableCellStyled align="left">Total Efetivo</TableCellStyled>
          </TableRowStyled>
        </TableHeadStyled>
        <TableBodyStyled>
          {tableData?.map((row) => (
            <TableRowStyled key={row}>
              <TableCellStyled>{row.mesAno}</TableCellStyled>
              <TableCellStyled align="left">{row.statusMov}</TableCellStyled>
              <TableCellStyled align="left">{row.ativo}</TableCellStyled>
              <TableCellStyled align="left">{row.demitido}</TableCellStyled>
              <TableCellStyled align="left">{row.eventual}</TableCellStyled>
              <TableCellStyled align="left">{row.acesso}</TableCellStyled>
              <TableCellStyled align="left">{row.afastado}</TableCellStyled>
              <TableCellStyled align="left">{row.substituto}</TableCellStyled>
              <TableCellStyled align="left">{row.transferido}</TableCellStyled>
              <TableCellStyled align="left">{row.total}</TableCellStyled>
            </TableRowStyled>
          ))}
          <TableRowStyled style={{ background: COLORS.lightGray }}>
            <TableCellStyled>Total</TableCellStyled>
            <TableCellStyled></TableCellStyled>
            <TableCellStyled align="left">
              {handleCalcTotal('ativo')}
            </TableCellStyled>
            <TableCellStyled align="left">
              {handleCalcTotal('demitido')}
            </TableCellStyled>
            <TableCellStyled align="left">
              {handleCalcTotal('eventual')}
            </TableCellStyled>
            <TableCellStyled align="left">
              {handleCalcTotal('acesso')}
            </TableCellStyled>
            <TableCellStyled align="left">
              {handleCalcTotal('afastado')}
            </TableCellStyled>
            <TableCellStyled align="left">
              {handleCalcTotal('substituto')}
            </TableCellStyled>
            <TableCellStyled align="left">
              {handleCalcTotal('transferido')}
            </TableCellStyled>
            <TableCellStyled align="left">
              {handleCalcTotal('total')}
            </TableCellStyled>
          </TableRowStyled>
        </TableBodyStyled>
      </TableStyled>
    </TableContainerStyled>
  )
}

export default TableContract
